import { useEffect, useState } from "react";
import { IResponseApiFluent, codigosRespuesta } from "../../../../../Interfaces/base/IResponse";
import { IPanelRazonModeloEliminar } from "./PanelRazonModeloEliminar";
import { IRazonModeloCommandEliminar } from "../../../../../Interfaces/auxiliar/IRazonModelo";
import RazonModeloService from "../../../../../services/auxiliar/RazonModeloService";

const UseRazonModeloEliminar = (props: IPanelRazonModeloEliminar) => {
    const [status, setStatus] = useState<codigosRespuesta>(0);
    const [mensaje, setMensaje] = useState<string>("");
    const [loading, setLoading] = useState<boolean>(false)
    const [contentShow, setcontentShow] = useState(true);
    const [loadprogress, setloadprogress] = useState(false);

    const initial: IRazonModeloCommandEliminar = {
        modeloId: "",
        razonId: ""
    }
    const [request, setRequest] = useState<IRazonModeloCommandEliminar>(initial)

    const deleteRazonModelo = () => {
        setLoading(true)
        RazonModeloService.EliminarRazonModelo(request)
            .then((res) => {
                if (res.status == 200) {
                    setStatus(200)
                    setloadprogress(true);
                    setcontentShow(false);
                    setMensaje(res.data.mensaje);
                    setTimeout(() => {
                        props.reload?.(request.razonId);
                        reset()
                    }, 3000)
                } else {
                    setStatus(500)
                }
                setLoading(false)

            })
            .catch((e) => {
                if (
                    e.response?.data &&
                    'type' in e.response.data &&
                    'title' in e.response.data &&
                    'status' in e.response.data &&
                    'instance' in e.response.data &&
                    'errors' in e.response.data
                ) {
                    const errorResponse = e.response.data as IResponseApiFluent;
                    const mensajeError = errorResponse.errors.join('\n');
                    setMensaje(mensajeError);
                } else {
                    console.log('Error detallado:', e);
                    setMensaje("Error Inesperado");
                }
                setStatus(500);
                setLoading(false);
            })
    }

    const reset = () => {
        setMensaje("")
        setRequest(initial)
        setStatus(0)
        setcontentShow(true)
        setLoading(false)
        setloadprogress(false)
        props.onDismiss()
    }

    useEffect(() => {
        if (props.item != initial) {
            setRequest({
                ...request,
                modeloId: props.item.equipoModeloId,
                razonId: props.item.razonId
            })
        }
    }, [props.item])


    return {
        request,
        setRequest,
        deleteRazonModelo,
        loading,
        reset,
        mensaje,
        status,
        contentShow,
        loadprogress
    }
}

export { UseRazonModeloEliminar }